import { US_BANK_FIX_PLAN_HEADERS } from '../../../../../../../../shared/featureFlags/flagNames';
import { useIsFeatureEnabled } from '../../../../../../../helpers/features';
import type { SelectOption, SetState } from '../../../../../../../types';
import FilterCardCheckboxes from '../../../../../../generic/Filter/FilterCardCheckboxes';
import { FixPlanReportOptionDetails } from '../../../utils';

import filterStyles from '../../../../../../generic/Filter/FilterCard.module.less';

type Props = {
  values: SelectOption[];
  setValues: SetState<SelectOption[]>;
};

const IncludeFixPlanCheckboxGroup = ({
  values,
  setValues,
}: Props) => {
  const areAlternativeTitlesEnabled = useIsFeatureEnabled(US_BANK_FIX_PLAN_HEADERS);
  const options = Object.values(FixPlanReportOptionDetails).map(({ key: value, title, alternativeTitle, isNested }) => {
    return {
      isNestedOption: isNested,
      label: areAlternativeTitlesEnabled ? alternativeTitle : title,
      value,
      isDisabled: false,
    };
  });

  return (
    <div className="width-full" data-test-id="fix-plan-filters-include">
      <FilterCardCheckboxes
        label="Report Sections Included"
        options={options}
        values={values}
        onChange={setValues}
        renderOption={(option, checkbox) => {
          // @ts-expect-error We know this field will exist, the types for FilterCardCheckboxes just don't support it well.
          if (option.isNestedOption) {
            return (<span className={filterStyles.filterNestedCheckboxes}>{checkbox}</span>);
          }
          return checkbox;
        }}
      />
    </div>);
};

export default IncludeFixPlanCheckboxGroup;
